<template>
  <div
    :class="`btn btn-w-m btn-${type}`"
    :style="`${btnWidth ? `width: ${btnWidth}; margin: 0 auto` : ''}`"
  >
    <i :class="icon" style="margin-left: 1px"></i>
    <template v-if="!loading">
      {{ title }}
    </template>
    <template v-else>
      <div class="g-spinner"></div>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
    },
    type: {
      type: String,
    },
    icon: {
      type: String,
    },
    title: {
      type: String,
    },
    btnWidth: {
      type: String,
    },
    loading: Boolean,
  },
};
</script>

<style lang="scss">
.g-spinner {
  width: 20px;
  height: 20px;
  border-color: #0ab8d2;

  display: inline-block;
  vertical-align: text-bottom;
  border: 2px solid;
  border-radius: 50%;
  border-left-color: transparent !important;
  animation: g-spinner 0.75s linear infinite;

  @keyframes g-spinner {
    to {
      transform: rotate(360deg);
    }
  }
}
</style>
